import { NOT_AUTHORIZED, NOT_AUTHORIZED_STATUS } from "../utils/constants";
import fetchRetry from "../utils/fetchRetry";
import { getPuPromotionUrl } from "../utils/urlUtils";

export const CANNOT_COLLECT_COUPON = "CannotCollectCoupon"
export const ALREADY_COLLECTED_COUPON = "AlreadyCollectedCoupon"
export const ERROR_COLLECTING_COUPON = "ErrorCollectingCoupon"

export const postCollectPromotionCoupon = (authToken: string, coupon_id: string) => {
    return new Promise((resolve, reject) => {
        const promoUrl = getPuPromotionUrl();
        if (!promoUrl) {
            reject(CANNOT_COLLECT_COUPON)
            return;
        }

        var pp_metadata_url = promoUrl + `/promotion/coupon/${coupon_id}/collect`
        const headers = new Headers();
        headers.append("Authorization", authToken);
        var myInit = {
            method: "POST",
            headers: headers
        };
        fetchRetry(pp_metadata_url, myInit).then(resp => {
            if (resp.status === 403) {
                resp.json().then((data) => reject(data?.message || CANNOT_COLLECT_COUPON));
            } else if (resp.status === 409) {
                reject(ALREADY_COLLECTED_COUPON);
            } else if (NOT_AUTHORIZED_STATUS.includes(resp.status)) {
                reject(NOT_AUTHORIZED);
            } else if (resp.status >= 300) {
                reject(ERROR_COLLECTING_COUPON);
            } else {
                resp.json().then((data) => resolve(data));
            }
        }).catch(err => {
            reject(err);
        });
    });
}